<script>
  import alterarSenhaServico from './servico';
  import tipoUsuario from '~js/tipo-usuario';

  export default {
    data() {
      return {
        atual: '',
        nova: '',
        confirmacao: '',
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');

        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              return (this.usuario.tipoUsuario === tipoUsuario.FornecedorWeb)
                ? alterarSenhaServico.alterarSenhaFornecedorWeb(this.atual, this.nova)
                : alterarSenhaServico.alterarSenha(this.atual, this.nova);
            } else {
              throw new Error("validacao");
            }
          })
          .then(() => {
            toastr.success(`Senha alterada com sucesso.`);

            if (this.usuario.tipoUsuario === tipoUsuario.Coordenador){
              this.usuario.senhaExpirada = false;
              this.$storage.usuario(this.usuario);
            }

            this.$router.push({ name: 'home' });
          })
          .catch(erro => {
            $('#salvar').button('reset');

            if (erro.status === 400) {
              this.$swal(
                '',
                (erro.bodyText != '') ? erro.bodyText :`Senha atual incorreta.`,
                'error'
              );
            } else {
              this.$mensagemErro(erro, 'Erro ao alterar a senha.');
            }
          });
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Alterar Senha';

      this.$root.botaoAcaoMostrar = false;
    },
    computed: {
      senhaExpirada() {
        return this.$storage.usuario().senhaExpirada;
      }
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="ibox float-e-margins">
        <div class="ibox-content">
          <div class="alert alert-danger" role="alert" v-show="senhaExpirada">
            Sua senha expirou, para manter a segurança do seu acesso. É necessário realizar a troca da senha.
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group required" :class="{'has-error': errors.has('senhaAtual')}">
                <label class="control-label" for="senha-atual">Senha atual</label>

                <input type="password"
                       class="form-control"
                       id="senha-atual"
                       v-model="atual"
                       data-vv-name="senhaAtual"
                       data-vv-as="Senha atual"
                       v-validate="'required'">

                <p class="text-danger" v-show="errors.has('senhaAtual')">{{ errors.first('senhaAtual') }}</p>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group required" :class="{'has-error': errors.has('novaSenha')}">
                <label class="control-label" for="nova-senha">Nova senha</label>

                <input type="password"
                       class="form-control"
                       id="nova-senha"
                       name="Nova senha"
                       v-model="nova"
                       data-vv-name="novaSenha"
                       data-vv-as="Nova senha"
                       v-validate="`required|senhaigual:${this.atual}|min:${this.configuracao.quantidadeMinSenha}`">

                <p class="text-danger" v-show="errors.has('novaSenha')">{{ errors.first('novaSenha') }}</p>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group required" :class="{'has-error': errors.has('confirmacaoSenha')}">
                <label class="control-label" for="confirmacao">Confirmação de senha</label>

                <input type="password"
                       class="form-control"
                       id="confirmacao"
                       v-model="confirmacao"
                       data-vv-name="confirmacaoSenha"
                       data-vv-as="Confirmação de senha"
                       v-validate="`required|confirmed:Nova senha|min:${this.configuracao.quantidadeMinSenha}`">

                <p class="text-danger" v-show="errors.has('confirmacaoSenha')">{{ errors.first('confirmacaoSenha') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <button id="salvar"
                        type="button"
                        class="btn btn-primary"
                        @click="salvar"
                        data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </div>
          </div>

          <!-- INÍCIO - AVISO DA REGRA DE CRIAÇÃO DE SENHAS NO PADRÃO LGPD  -->
          <div class="MuiPaper-root MuiCard-root MuiPaper-elevation1 MuiPaper-rounded">
            <div class="MuiCardContent-root">
              <div class="eUJFoz">
                <div class="ibZHkU">
                  <h4 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold">Regras para a criação de senhas no padrão LGPD</h4>
                  <h5 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold"><i class='fa fa-check' style="color: #228B22"></i>Conter entre 8 e 16 caracteres;</h5>
                  <h5 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold"><i class='fa fa-check' style="color: #228B22"></i>Não pode conter 3 ou mais caracteres repetidos em sequência;</h5>
                  <h5 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold"><i class='fa fa-check' style="color: #228B22"></i>Não pode conter números em sequência crescente ou decrescente, por exemplo: 1, 2 ou 2, 1;</h5>
                  <h5 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold"><i class='fa fa-check' style="color: #228B22"></i>Precisa ter pelo menos um caracter em maiúsculo;</h5>
                  <h5 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold"><i class='fa fa-check' style="color: #228B22"></i>Precisa ter pelo menos um caracter em minúsculo;</h5>
                  <h5 class="MuiTypography-root jJlyZM MuiTypography-h6 MuiTypography-colorTextPrimary font-bold"><i class='fa fa-check' style="color: #228B22"></i>Precisa ter pelo menos um caracter especial, por exemplo: *, &, [, {, ( ou $, entre outros.</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- FIM - AVISO DA REGRA DE CRIAÇÃO DE SENHAS NO PADRÃO LGPD -->

        </div>
      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/alterar-senha/AlterarSenha.vue